import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as DatasetActions from './google-sheet.actions';
import { CreateGoogleSheetProps } from '@mode/dataset/contract';
import { GoogleSheetFacade } from '@mode/dataset/contract';
import { take, combineLatest } from 'rxjs';
import { DatasetBrowserData, DataViewTypes, FlamingoTypes } from '@mode/shared/contract-common';
import { AccountFacade } from '@mode/accounts/contract';
import { ChartFacade } from '@mode/charts/contract';
import { SwitchViewFacade } from '@mode/switch-views/contract';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ReportFacade } from '@mode/reports/domain';

@Injectable()
export class GoogleSheetFacadeService implements GoogleSheetFacade {
  constructor(
    private store: Store,
    private chartFacade: ChartFacade,
    private reportFacade: ReportFacade,
    private switchViewFacade: SwitchViewFacade,
    private accountFacade: AccountFacade
  ) {}

  createGoogleSheetDataset(props: CreateGoogleSheetProps) {
    this.store.dispatch(DatasetActions.createGoogleSheetDataset(props));
  }

  public importDataset(dataset: DatasetBrowserData) {
    combineLatest([this.accountFacade.defaultCategoricalPalette$, this.accountFacade.currentOrg$])
      .pipe(take(1))
      .subscribe({
        next: ([palette, org]) => {
          const chartData = this.createChartEncodingAndFormats(dataset);
          const accountId = org.username;
          this.handleImportFromSearch(accountId, dataset, palette.token, chartData);
        },
        error: (e) => console.error(e),
      });
  }

  private handleImportFromSearch(accountId: string, dataset: DatasetBrowserData, paletteToken: string, chartData: any) {
    this.reportFacade.createReportAndChartFromDatasetBrowserSearch(
      accountId,
      dataset.switchViewToken,
      paletteToken,
      chartData.encWithColumns?.encoding,
      chartData.chartFormats.format,
      chartData.chartFormats.fieldsFormat
    );
  }
  private createChartEncodingAndFormats(dataset: DatasetBrowserData) {
    const switchAttrs = dataset.switchAttrs ?? [];
    const attrs: FlamingoTypes.ModeAttr[] = this.switchViewFacade.makeAttrs(switchAttrs);
    const switchView = this.switchViewFacade.createSwitchView(
      <string>dataset.queryToken,
      <string>dataset.queryRunToken,
      <DataViewTypes.DatasetResourceColumn[]>dataset.metaColumns,
      attrs
    );
    const enc = this.chartFacade.createTableChartEncoding();
    const model = this.switchViewFacade.makeView(switchView);
    const columns = this.chartFacade.createTableColumns(model);

    return {
      encWithColumns: this.chartFacade.addRemainingColumnsToTable(enc, model, <string>dataset?.queryToken),
      chartFormats: this.chartFacade.createTableChartFormats(columns),
    };
  }
}
